'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const ViewsByDayChartClient = dynamic(() => import('./ViewsByDayChartClient'), { ssr: false });

export default function ViewsByDayChart() {
  return (
    <div className="card-surface p-5">
      <div className="mb-4">
        <h3 className="font-bold text-base text-foreground">Profile Views by Day</h3>
        <p className="text-xs text-muted-foreground">Average views per day of the week (last 30 days)</p>
      </div>
      <ViewsByDayChartClient />
    </div>
  );
}